export const SECTION_PATHS = Object.freeze({
  'how-it-works': '/how-it-works',
  pricing: '/pricing',
  modules: '/modules',
  plans: '/plans',
  contact: '/contact',
});
